import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

import { useDispatch, useSelector } from 'react-redux'
import { addForm } from '../../../redux/formsSlice'
import Heading from './Heading'
import Collapsible from './Collapsible'
import AddJoinModal from './AddJoinModal'
import { addColumn } from '../../../redux/columnsSlice'
import { addJoin, AddConditions } from '../../../redux/joinsSlice'
import getValidatedForms from "../../../api/getValidatedForms"
import { useQuery } from 'react-query'
import { addTable, dropTables } from '../../../redux/researchSlice';
import Loader from '../../utilities/loader';

const JoinForms = () => {
    const selectedProject = useSelector(state => state.selectedProject);
    const researchData = useSelector(state => state.research);
    const forms = useSelector((state) => state.forms)
    const joins = useSelector((state) => state.joins)
    const research = useSelector(state => state.research);
    const columns = useSelector((state) => state.columns)
    let { isLoading, data: availableForms } = useQuery("getValidatedForms" + selectedProject.name, () => getValidatedForms(selectedProject.name))
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isAddJoinModalOpen, setIsAddJoinModalOpen] = useState(false)
    const [isCollapseOpen, setIsCollapseOpen] = useState(true)
    const [deleteing, setDeleteing] = useState(false);
    const dispatch = useDispatch();
    // console.log("research in join from => ", research)

    const addFormClick = () => {
        if (forms.length < 2) {
            setDeleteing(false);
            dispatch(addForm(selected))
            // dispatch(addColumn());
        }
    }

    const toggleModal = () => {
        if (forms.length < 2) {
            setIsModalOpen(!isModalOpen)
        }
        else {
            setIsAddJoinModalOpen(!isAddJoinModalOpen);
        }
    }

    const selectItem = (name) => {
        selected = name
        addFormClick();
        toggleModal();
    }

    useEffect(() => {
        dispatch(dropTables())
        forms.forEach((form) => {
            dispatch(addTable({ form_name: form }));
        })
        if (forms.length === 2 && !deleteing && joins.length < 1) {
            dispatch(addJoin([0, 1]));
            // dispatch(addTable({ form_name: forms[0] }));
            // dispatch(addTable({ form_name: forms[1] }));
            var addInnerConditionArray = [];
            addInnerConditionArray.push([0, 0]);
            dispatch(AddConditions({ conditions: addInnerConditionArray, index: 0 }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forms, joins])

    if (isLoading) return <><Loader /></>

    availableForms = availableForms.data.map((val) => val);
    let selected = availableForms[0];

    return (
        <div className="recent-activities">
            <Heading isCollapseOpen={isCollapseOpen} setIsCollapseOpen={setIsCollapseOpen} />
            <Collapsible setDeleteing={setDeleteing} toggleJoinModal={toggleModal} isCollapseOpen={isCollapseOpen} toggleModal={toggleModal} />
            <AddJoinModal isModalOpen={isAddJoinModalOpen} toggleModal={toggleModal} />
            <Modal isOpen={isModalOpen} toggle={toggleModal} >
                <ModalHeader toggle={toggleModal}>
                    Sélectionner formulaire
                </ModalHeader>
                <ModalBody>
                    <div className="flex flex-wrap justify-evenly gap-2">
                        {!availableForms.length && "No more forms left"}
                        {availableForms.map((name) =>
                            <div style={{ background: "#FFFFFF" }}
                                className="cursor-pointer py-2 px-4 border-2 rounded"
                                onClick={() => selectItem(name)}>
                                {name}
                            </div>)}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={toggleModal}>Annuler</Button>
                </ModalFooter>
            </Modal>

        </div >
    )
}






export default JoinForms
